import axios from "axios";
import { getOrSetCookie } from "../utils/cookieUtil";
import { EngagementRequest, EngagementResponse } from "redmond";
import { PATH_ENGAGEMENT_EVENT } from "../constants/urlPaths";
import { v4 as uuidv4 } from "uuid";

// using direct axios call b/c used in sagas and other non-React contexts
export const trackEngagementEvent = async (req: EngagementRequest): Promise<EngagementResponse> => {
    try {
        const res = await axios.post(
            `${PATH_ENGAGEMENT_EVENT}`,
            {
                event: {
                    ...req.event,
                    url: window.location.href,
                    browser_session_id: getOrSetCookie(
                        "browser_session_id",
                        uuidv4()
                    ),
                },
            }
        );
        return res.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
};
